import { getFormsBaseUrl } from '@/helpers/env'
import axios from 'axios'
import querystring from 'querystring'
import {
  OLO_APPLICATION_NAME_HEADER,
  OLO_APPLICATION_NAME_VALUE,
} from '@/constants/api'

const FORMS_API_BASE_URL = getFormsBaseUrl()

const formsApi = axios.create({
  baseURL: FORMS_API_BASE_URL,
  headers: {
    [OLO_APPLICATION_NAME_HEADER]: OLO_APPLICATION_NAME_VALUE,
  },
})

export const API_URL_FORMS_PRESETS = 'presets'

export const constructFormAttributesUrl = function(
  merchantSlug: string,
  formType: string,
  formSlug: string | undefined
) {
  return `/${API_URL_FORMS_PRESETS}?${querystring.stringify({
    merchant_slug: merchantSlug,
    form_slug: formSlug,
    form_type: formType,
  })}`
}

export const getFormType = context => {
  return window.location.host.indexOf('waitlist') > -1 ||
    context.$route.path.indexOf('waitlist') > -1
    ? 'waitlist'
    : 'reservations'
}

export default formsApi
